import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomHttp } from '../../../common/customHttp.service';
import { ApiUrl } from '../../../common/apiUrls';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { MainAppComponent } from '../../../layout/layout.component';
import { ToastrService } from 'ngx-toastr';
import { ValidationService } from '../../../common/validationservice';

declare var $: any;
@Component({
    selector: 'editanalysiselements',
    templateUrl: './editanalysiselements.component.html',
    styleUrls: ['./editanalysiselements.component.scss']
})
export class EditAnalysisElements implements OnInit {
    editAnalysisElementsForm: FormGroup;
    anlysElement: any;
    lstAnalysisElements: any[];
    lstAnalysisElementsSrch: any[];
    lstCustomers: any;
    isSubmitted: boolean = false;
    isFormValid: boolean = true;
    lstSelected: any[];
    lstSelectedSrch: any[];
    lstSampleTypes: any[];
    lstTemp: any;
    items: any[] = [{ CharacteristicId: 2, Name: "Break Down Voltage1" }];

    selected: any[] = [{ id: 1, name: 'Movie 1', url: '' }];
    constructor(public _router: Router, private _formBuilder: FormBuilder,
        private _http: CustomHttp,
        private _appUrl: ApiUrl, private _route: ActivatedRoute, private _validationService: ValidationService,
        private _mApp: MainAppComponent, private _toastrService: ToastrService) {

    }

    ngOnInit() {
        let sectionId = this._route.snapshot.params['id'];
        this.editAnalysisElementsForm = this._formBuilder.group({
            AnalysisElementSectionTypeId: [0],
            Name: ['', Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(50)])],
            // CustomerId: [0,Validators.compose([Validators.required,this._validationService.ValidateDropdownList])],
            OrderId: ['', Validators.compose([Validators.required, Validators.min(1), Validators.max(50)])],
            lstChars: [],
            SelectedChars: [],
            SelectedCharIds: [],
            SampleTypeId: ['', Validators.compose([Validators.required, this._validationService.ValidateDropdownList])]
            // lstAnalysisElements:[]
        })
        this.GetCustomers();
        this.GetSampleTypes();
        this.GetAnalysisSectionElements(sectionId);

    }

    GetAnalysisSectionElements(sectionId) {
        this._mApp.ShowLoader();
        this._http.get(this._appUrl.GetAnalysisSectionElementsList + sectionId)
            .subscribe(
                data => {

                    this._mApp.HideLoader();
                    this.anlysElement = data.json().Result;
                    this.lstAnalysisElements = this.anlysElement.lstChars;
                    this.lstAnalysisElementsSrch = this.lstAnalysisElements;
                    this.lstTemp = JSON.stringify(this.anlysElement.lstChars);
                    this.lstSelected = this.anlysElement.SelectedChars;
                    this.lstSelectedSrch = this.lstSelected;
                    this.editAnalysisElementsForm.setValue(data.json().Result);

                },
                error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result);
                }
            )
    }

    GetCustomers() {
        this._http.get(this._appUrl.GetCustomersMinInfoList)
            .subscribe(
                data => {
                    this.lstCustomers = data.json().Result;
                },
                error => {
                    this._toastrService.error(error.json().Result, '')
                }
            )
    }

    onSubmit() {
        this.FilterChars('', 2);
        this.isSubmitted = true;
        if (this.editAnalysisElementsForm.valid) {
            this._mApp.ShowLoader();
            let analysElement = this.editAnalysisElementsForm.value;
            analysElement.lstChars = this.lstAnalysisElements;
            analysElement.SelectedChars = this.lstSelected;
            this._http.post(this._appUrl.UpsertSectionName, analysElement)
                .subscribe(
                    data => {
                        this._mApp.HideLoader();
                        this._toastrService.success(data.json().Result);
                        this._router.navigate(['/analysisreportconfiglist']);
                    },
                    error => {
                        this._mApp.HideLoader();
                        this._toastrService.error(error.json().Result);
                    }
                )
        }
    }

    onFilterChange() {
        for (let i = 0; i < this.lstAnalysisElements.length; i++) {
            if (this.lstAnalysisElements[i].IsChecked == true) {
                if (this.lstAnalysisElements[i].CharacteristicOrderId == undefined || this.lstAnalysisElements[i].CharacteristicOrderId == "" || this.lstAnalysisElements[i].CharacteristicOrderId == null) {
                    this.isFormValid = false;
                    return;
                }
                else {
                    this.isFormValid = true;
                }
            }
            else {
                this.isFormValid = true;
            }
        }
    }

    FilterChars(val, order) {
        if (order == 1)
            this.lstAnalysisElements = this.lstAnalysisElementsSrch.filter(m => m.Name.toLowerCase().indexOf(val.toLowerCase()) === 0);
        else if (order == 2)
            this.lstSelected = this.lstSelectedSrch.filter(m => m.Name.toLowerCase().indexOf(val.toLowerCase()) === 0);
    }
    BindAvailableToselect() {

        this._mApp.ShowLoader();
        this.lstAnalysisElements.filter(m => m.IsChecked == true).forEach((item, index) => {
            this.lstSelectedSrch.push({
                CharacteristicId: item.CharacteristicId,
                Name: item.Name,
                IsChecked: false
            });

            this.lstAnalysisElementsSrch = this.lstAnalysisElementsSrch.filter(m => m.CharacteristicId != item.CharacteristicId);
        })
        // this.lstSelectedSrch = this.lstSelected;
        let srchTxt = $('#txtSelectedCharsSrch').val();
        this.FilterChars(srchTxt, 2);
        this._http.post(this._appUrl.SortArrayByAscending, this.lstAnalysisElementsSrch)
            .subscribe(
                data => {

                    this._mApp.HideLoader();
                    this.lstAnalysisElements = data.json().Result;
                    this.lstAnalysisElementsSrch = data.json().Result;
                },
                error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result);
                }
            )

    }

    BindSelectedToAvailable() {

        this._mApp.ShowLoader();
        this.lstSelected.filter(m => m.IsChecked == true).forEach((item, index) => {
            this.lstAnalysisElementsSrch.push({
                CharacteristicId: item.CharacteristicId,
                Name: item.Name,
                IsChecked: false
            });

            this.lstSelectedSrch = this.lstSelectedSrch.filter(m => m.CharacteristicId != item.CharacteristicId);
        })
        this.lstSelected = this.lstSelectedSrch;
        let srchTxt = $('#txtAvailableCharsSrch').val();
        this._http.post(this._appUrl.SortArrayByAscending, this.lstAnalysisElementsSrch)
            .subscribe(
                data => {
                    this._mApp.HideLoader();
                    // this.lstAnalysisElements = data.json().Result;
                    this.lstAnalysisElementsSrch = data.json().Result;
                    this.FilterChars(srchTxt, 1);
                },
                error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result);
                }
            )
    }

    GetSampleTypes() {
        this._http.get(this._appUrl.GetMinInfoSampleTypes)
            .subscribe(
                data => {
                    if (data.json().Result != null) {
                        this.lstSampleTypes = data.json().Result;
                        this.lstSampleTypes = this.lstSampleTypes.filter(m => m.SampleTypeId != 3);
                    }
                },
                error => {
                    this._toastrService.error(error.json().Result);
                }
            )
    }
}